import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/registrars/domains/loading';

export const Route = createFileRoute('/_private/settings/registrars/_template/$id/domains')({
  staticData: {
    pageTitle: 'Domains',
    tabKey: 'settings/registrar/domains',
  },
  pendingComponent: Loading,
});
